import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fb599c72")
const _hoisted_1 = { class: "p-formgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_3 = { class: "other" }
const _hoisted_4 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_5 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_6 = { class: "other" }
const _hoisted_7 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_8 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_9 = { class: "other" }
const _hoisted_10 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_11 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_12 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_13 = { class: "p-field p-fluid" }
const _hoisted_14 = { class: "p-grid" }
const _hoisted_15 = { class: "p-field p-col-6" }
const _hoisted_16 = { class: "p-field p-col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CompanyAutocomplete = _resolveComponent("CompanyAutocomplete")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
      : (_openBlock(), _createBlock(_component_Fieldset, { key: 1 }, {
          legend: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_FloatLabel, { label: "Project Name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.project.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.project.name = $event)),
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_FloatLabel, { label: "Work Type Description" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.project.work_type_description,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.project.work_type_description = $event)),
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FloatLabel, { label: "Status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Dropdown, {
                        style: {"width":"100%"},
                        modelValue: _ctx.project.status,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.project.status = $event)),
                        options: _ctx.statusOptions,
                        placeholder: "Select status",
                        "option-value": "value",
                        "option-label": "label"
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_CompanyAutocomplete, {
                    label: "Client",
                    type: 200,
                    modelValue: _ctx.project.client,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.project.client = $event)),
                    onSelect: _ctx.changeClient,
                    showDropdown: true
                  }, null, 8, ["modelValue", "onSelect"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_FloatLabel, { label: "Expected Start Date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Calendar, {
                        style: {"width":"100%"},
                        modelValue: _ctx.project.expectedStart,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.project.expectedStart = $event)),
                        showIcon: true,
                        showTime: false,
                        dateFormat: 'yy-mm-dd'
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_FloatLabel, { label: "Expected End Date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Calendar, {
                        style: {"width":"100%"},
                        modelValue: _ctx.project.expectedEnd,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.project.expectedEnd = $event)),
                        showIcon: true,
                        showTime: false,
                        dateFormat: 'yy-mm-dd'
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_FloatLabel, { label: "Week Days" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Dropdown, {
                        style: {"width":"100%"},
                        options: _ctx.week_days,
                        optionLabel: "label",
                        optionValue: "value",
                        modelValue: _ctx.project.week_days,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.project.week_days = $event))
                      }, null, 8, ["options", "modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_FloatLabel, { label: "Project description and information" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Textarea, {
                      modelValue: _ctx.project.description,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.project.description = $event)),
                      rows: "4"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_CompanyAutocomplete, {
                    label: "Customer",
                    type: 300,
                    modelValue: _ctx.selectedCustomer,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedCustomer = $event)),
                    disabled: _ctx.requestPending,
                    onSelect: _ctx.addCustomer
                  }, null, 8, ["modelValue", "disabled", "onSelect"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_DataTable, {
                  value: _ctx.project.project_customers,
                  loading: _ctx.requestPending,
                  stripedRows: "",
                  rows: 10,
                  "rows-per-page-options": [10, 20, 50, 100],
                  paginator: true,
                  "auto-layout": true,
                  "striped-rows": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      header: "Name"
                    }),
                    _createVNode(_component_Column, {
                      field: "email",
                      header: "Email"
                    }),
                    _createVNode(_component_Column, {
                      field: "phone",
                      header: "Phone"
                    }),
                    _createVNode(_component_Column, {
                      field: "business_name",
                      header: "Business name"
                    }),
                    _createVNode(_component_Column, {
                      field: "business_address",
                      header: "Business address"
                    }),
                    _createVNode(_component_Column, {
                      field: "business_city",
                      header: "Business city"
                    }),
                    _createVNode(_component_Column, {
                      field: "business_country",
                      header: "Business country"
                    }),
                    _createVNode(_component_Column, {
                      header: "Actions",
                      class: "column-header-right p-text-right",
                      style: {"min-width":"100px","width":"100px"}
                    }, {
                      body: _withCtx(({data}) => [
                        _withDirectives(_createVNode(_component_Button, {
                          class: "p-button-danger",
                          icon: "pi pi-trash",
                          onClick: _withModifiers(($event: any) => (_ctx.onRemove(data)), ["stop"])
                        }, null, 8, ["onClick"]), [
                          [
                            _directive_tooltip,
                            'Remove customer',
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _renderSlot(_ctx.$slots, "actions", { data: data }, undefined, true)
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["value", "loading"])
              ])
            ])
          ]),
          _: 3
        }))
  ]))
}